import { publicPaginationSchema, schemes, zSchema } from "@zeal/common";

export const ACCRUAL_POLICIES_WORKERS_BY_IDS_MAX = 500;

export const getAccrualPoliciesWorkersRequestSchema = zSchema
  .object({
    companyID: schemes.companyID(),
    q: zSchema.string().optional(),
    worker_ids: zSchema
      .array(schemes.mongoObjectId())
      .max(ACCRUAL_POLICIES_WORKERS_BY_IDS_MAX)
      .optional(),
    ...publicPaginationSchema.shape,
  })
  .refine((value) => !value.q?.trim() || !value.worker_ids?.length, {
    message: "q and worker_ids cannot be used together",
  });

export type TGetAccrualPoliciesWorkersRequestSchema = zSchema.infer<
  typeof getAccrualPoliciesWorkersRequestSchema
>;

export const getAccrualPoliciesWorkersResponseSchema = zSchema.array(
  zSchema.object({
    id: schemes.mongoObjectId(),
    first_name: zSchema.string(),
    middle_name: zSchema.string(),
    last_name: zSchema.string(),
  })
);

export type TGetAccrualPoliciesWorkersResponseSchema = zSchema.infer<
  typeof getAccrualPoliciesWorkersResponseSchema
>;
